export default {
  root: ({ props, context, parent }) => ({
    class: [
      // Font
      'leading-none',

      // Flex
      { 'flex-1 w-[1%]': parent.instance.$name == 'InputGroup' },

      // Spacing
      'm-0',
      'py-2',
      {
        'px-4 text-text-lg h-12': props.size == 'large',
        'px-3 text-text-sm h-8': props.size == 'small',
        'px-3 text-text-md h-10': props.size == null
      },

      // Shape
      { 'rounded-xs': parent.instance.$name !== 'InputGroup' },
      {
        'first:rounded-l-xs rounded-none last:rounded-r-xs': parent.instance.$name == 'InputGroup'
      },
      { 'border-0 border-y border-l last:border-r': parent.instance.$name == 'InputGroup' },
      { 'first:ml-0 -ml-px': parent.instance.$name == 'InputGroup' && !props.showButtons },

      // Colors
      'text-surface-700 dark:text-surface-200',
      'placeholder:text-gray-700 dark:placeholder:text-surface-500',
      { 'bg-white dark:bg-surface-900': !context.disabled },
      'border',
      { 'border-gray-600 dark:border-surface-600': !props.invalid },
      { 'bg-gray-300 border-gray-600 text-gray-700': context.disabled },

      // Invalid State
      { 'border-red-300 dark:border-red-400': props.invalid },

      // States
      {
        'focus:outline-primary-400 dark:focus:outline-primary-400':
          !context.disabled && !props.invalid,
        'focus:outline-red-300': !context.disabled && props.invalid,
        'select-none pointer-events-none cursor-not-allowed': context.disabled //opacity-60
      },

      // Filled State *for FloatLabel
      { filled: parent.instance?.$name == 'FloatLabel' && context.filled },

      // Misc
      'appearance-none',
      'transition-colors duration-200'
    ]
  })
}
